// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37d25aec","455":"1666dbb6","977":"55ddf259"}[chunkId] + ".chunk.js";
};